export const SECOND = 1000;
export const MINUTE = 60 * SECOND;

export const ANS_NOTFICATION_INTERVAL_MS = 1 * MINUTE;
export const colors = [
	"#FFFFFF",
	"#000000",
	"#ff0000",
	"#ff8700",
	"#ffd300",
	"#deff0a",
	"#a1ff0a",
	"#0aff99",
	"#0aefff",
	"#147df5",
	"#580aff",
	"#be0aff",
];
export const MIN_STROKE = 4;
export const MAX_STROKE = 100;

// Set fabric selection styles:
export const SELECTION_COLOR = "#04ff27";
export const SELECTION_COLOR_TRANSPARENT = `color-mix(in srgb, ${SELECTION_COLOR} 60%, transparent)`;
export const SELECTION_COLOR_TRANSPARENT_LESS = `color-mix(in srgb, ${SELECTION_COLOR} 20%, transparent)`;
export const SELECTION_BORDER_SIZE = 5;
export const WIDTH = 980;
export const HEIGHT = 1897;
export const initialScale = 1;
export const initialX = 0;
export const initialY = 0;
export const WIDGET_TARGET_WIDTH = 900;
export const WIDGET_TARGET_HEIGHT = 400;
export const GRID_SIZE = 50;
export const MIN_SCALE = 1;
export const MAX_SCALE = 6;

// export const ANS_NOTFICATION_INTERVAL_MS = 10 * SECOND;
